import { IApp } from '@/types/nuxt'
import refresh from '@/utils/refresh'

export default class GetTalkUseCase implements BaseUseCase {
  constructor(protected App: IApp) {}

  async execute(room: string, id: string) {
    try {
      await refresh(this.App)
      return await this.App.monitaroGateway.Talk.GetTalk(room, id)
    } catch (exception: any) {
      this.App.logService.handle(exception)
    }
    return null
  }
}
